var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M7.005 11.59 9.595 9a1 1 0 0 0 0-1.41L7.005 5a1 1 0 0 0-1.71.71v5.18a1 1 0 0 0 1.71.7"}})])}
var staticRenderFns = []

export { render, staticRenderFns }